import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { setBookingCardId, toggleSendInvoice } from 'components/actions/bookingActions'
import InvoiceBookingHelper from 'components/common/helpers/InvoiceBookingHelper';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import styles from '../../customStylesRadioButton';
import T from 'components/common/translations/Translate';

class InvoiceCheckbox extends Component {

  render() {
    const { invoiceData, handleOpenModal, sendInvoice,
      toggleSendInvoice } = this.props;
    var helper = new InvoiceBookingHelper(invoiceData);

    if (helper.isEmptyForm()) {
      // full empty form
      return (
        <p>
          <T>content.invoiceCheckbox.company</T>{' '}
          <a href="" onClick={handleOpenModal}>
            <T>content.invoiceCheckbox.addInvoice</T>
          </a>
        </p>
      );
    } else if (helper.isPartialEmptyForm()) {
      // partial empty form
      return (
        <p>
          <T>content.invoiceCheckbox.canceledInfo</T>
          <br />
          <T>content.invoiceCheckbox.fillTheForm.first</T>
          <a href="" onClick={handleOpenModal}><T>content.invoiceCheckbox.fillTheForm.last</T></a>
        </p>
      );
    } else {
      // not empty form
      return (
        <div className="invoice-checkox-marg">
          <label htmlFor="invoice" className="text-normal no-marg">
            <Checkbox
              id="invoice"
              checked={sendInvoice}
              onChange={toggleSendInvoice}
              classes={{
                root: this.props.classes.root,
                checked: this.props.classes.checked,
              }}
              className="checkbox-button"
              name="invoice"
            />
            <T>content.invoiceCheckbox.issueInvoice</T> <span className='invoice-name'>{invoiceData.invoiceCompany}</span>
          </label>
          <br />
          <a href="" onClick={handleOpenModal}>
            <T>content.invoiceCheckbox.changeInfo</T>
          </a>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    invoiceData: state.booking.invoiceData,
    sendInvoice: state.booking.sendInvoice
  };
};

export default connect(
  mapStateToProps,
  { setBookingCardId, toggleSendInvoice }
)(withStyles(styles)(InvoiceCheckbox));